import { clearTemp } from '../prototypes/clearTemp';
import { loadMissingFontsFromNode } from './loadMissintFontsFromNode';

export const safeAppendNode = async (node: SceneNode, tempLayer: FrameNode) => {
  try {
    tempLayer.appendChild(node);
  } catch (e) {
    const figmaError = e as Error;

    if (figmaError.message.includes('unloaded font')) {
      await loadMissingFontsFromNode(node);
    }

    node.remove();
    clearTemp();
  }
};
